export const WEIGHT_UNITS = [
  { label: 'Grams (g/kg)', value: 'grams' },
  { label: 'Pounds (lb)', value: 'pounds' },
];

export const GRAM_OPTIONS = [
  '1g',
  '2g',
  '3g',
  '4g',
  '5g',
  '10g',
  '20g',
  '50g',
  '100g',
  '500g',
  '1kg',
  '2kg',
  '5kg',
  '10kg',
  '15kg',
  '20kg',
  '25kg',
  '30kg',
  '35kg',
  '40kg',
];

export const POUND_OPTIONS = [
  '1/32lb',
  '1/16lb',
  '1/8lb',
  '1/4lb',
  '1/2lb',
  '1lb',
  '2lb',
  '3lb',
  '5lb',
  '6lb',
  '7lb',
  '8lb',
  '9lb',
  '10lb',
  '15lb',
  '20lb',
  '25lb',
  '30lb',
  '35lb',
  '40lb',
];
